define('taoQtiItem/qtiCreator/editor/gridEditor/config',[],function(){
    "use strict";
    return {
        min : {
            interaction : 2,
            text : 1,
            rubricBlock : 12
        },
        throttle : {
            resize : 100
        }
    };
});



